import { authorisedFetch } from 'api/rest/authorisedFetch';
import { TRADERS_API_URL } from 'data/constants';
import { TraderBalances } from 'data/traders/account/models/Trader';
import { parseItemStrict } from 'utils/parser/parseResponse';

export async function getTraderBalance() {
  const result = await authorisedFetch(`${TRADERS_API_URL}/account/balance`, {
    method: 'GET',
  });

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to get account: ${responseBody}`);
  }

  // Must go below previous response reading (in case of error)
  const data = await result.json();

  return parseItemStrict(TraderBalances, data);
}
